import "./Home.module.css";
import Intestazione from "@/reusable_sections/Header";
import SicilianPastryEssence from "./sections/SicilianPastryEssence";
import INostriValoriArtigianali from "./sections/INostriValoriArtigianali";
import OrdinaSubitoSuWhatsapp from "./sections/OrdinaSubitoSuWhatsapp";
import TasteCategories from "./sections/TasteCategories";
import VetrinaDelleTorteDautore from "./sections/VetrinaDelleTorteDautore";
import TestimonianzeDiDolcezza from "./sections/TestimonianzeDiDolcezza";
import PieDiPagina from "@/reusable_sections/Footer";
import ISegretiDellaTradizione from "./sections/ISegretiDellaTradizione";
export default function HomePage() {
  return <div>
      <Intestazione />
      <SicilianPastryEssence />
      <INostriValoriArtigianali />
      <OrdinaSubitoSuWhatsapp />
      <ISegretiDellaTradizione />
      <TasteCategories />
      <VetrinaDelleTorteDautore />
      <TestimonianzeDiDolcezza />
      <PieDiPagina />
    </div>;
}